import { useGLTF } from '@react-three/drei';
import { CuboidCollider, RigidBody } from '@react-three/rapier';
import { useRef } from 'react';

import factory from '@/assets/models/factory.glb';
import Animator from '@/components/game/3d/animation/Animator';

const FactoryComposed = ({ index }) => {
	const { nodes } = useGLTF(factory); //, materials
	const scale = 0.07;

	const meshRef = useRef<any>(null);

	const animationParam = {
		position_x_offset: index * 1.5,
		position_y_start: -3,
		position_y_final: 0,
	};

	const factoryMesh = () => {
		return (
			<RigidBody type="fixed" colliders={false}>
				<CuboidCollider
					position={[index * 1.5, 0, 0]}
					args={[1, 1, 1]}
				/>
				<mesh
					ref={meshRef}
					castShadow
					receiveShadow
					geometry={(nodes.Factory as any).geometry}
					rotation={[0, Math.PI, 0]}
					scale={scale}
				>
					<meshStandardMaterial color="#fafafa" transparent />
				</mesh>
			</RigidBody>
		);
	};

	return (
		<group dispose={null}>
			<Animator
				customMesh={factoryMesh()}
				meshRef={meshRef}
				animationParam={animationParam}
			/>
		</group>
	);
};

useGLTF.preload(factory);

export default FactoryComposed;
